import { render, staticRenderFns } from "./InventoryItemStatusSelect.vue?vue&type=template&id=1c590555"
import script from "./InventoryItemStatusSelect.vue?vue&type=script&lang=ts"
export * from "./InventoryItemStatusSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports